<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> account_balance </v-icon>
      <span :class="ui.textHeadline"> Company </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Company management, support functions, statistics, preferences.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-spacer/>
        <v-btn :color="ui.colorWarning" flat dark
        v-if="this.getUser.pref.select.cdid === null || this.getUser.pref.select.cdid === ''">
          <v-icon left>
            info
          </v-icon>
          Select Company
        </v-btn>
        <v-btn :color="ui.btnColor" flat dark @click="goToCompanyDash()"
        v-if="this.getUser.pref.select.cdid !== null && this.getUser.pref.select.cdid !== ''">
          <v-icon left>
            apps
          </v-icon>
          select
        </v-btn>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import pageAccess from "@/frame/control/mixins/pageAccess.js";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, adminFunctions, pageAccess],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser"])
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
